import React, { useState, useEffect } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import {
  makeStyles,
  IconButton,
  InputAdornment,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TablePagination,
  Checkbox,
  Box,
  Switch,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import People from "@material-ui/icons/People";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { CloudUpload } from '@material-ui/icons';
import * as XLSX from 'xlsx';
import { ImportExcel } from "../Master/ImportExcel";

// import TrendingMastersView from "./TrendingMastersView";
// import TrendingMastersAdd from "./TrendingMastersAdd";
// import TrendingMastersEdit from "./TrendingMastersEdit";
import {
  GetAllReadyMastersAPI,
  GetBulkReadyMasterRangeAPI,
  DeleteReadyMasterRangeAPI,
  baseUrl,
  // ImportReadyMasterRangeAPI,
  // ExportReadyMasterRangeAPI,
} from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import { useSelector } from "react-redux";
import ReadyMasterRangeAdd from "./ReadyMasterRangeAdd";
import ReadyMasterRangeView from "./ReadyMasterRangeView";
import ReadyMasterRangeEdit from "./ReadyMasterRangeEdit";
import { toast } from "react-toastify";
import { Search } from "@material-ui/icons";
import { formatINRCurrency } from "../../utils/index.js";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "productName", label: "Product" },
  { id: "startSph", label: "Start Sph" },
  { id: "endSph", label: "End Sph" },
  { id: "startCyl", label: "Start Cyl" },
  { id: "endCyl", label: "End Cyl" },
  { id: "startAddition", label: "Start Addn" },
  { id: "endAddition", label: "End Addn" },
  {
    id: "axis",
    label: "Axis",
    format: (value) => {
      if (Array.isArray(value)) {
        return value.map((v, index) => (index === value.length - 1 ? v : v + ","));
      }
      return value;
    },
  },
  { id: "index", label: "Index" },
  { id: "side", label: "Side" },
  {
    id: "rate",
    label: "Rate",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "type", label: "Type" },
  { id: "brand", label: "Brand" },
  { id: "color", label: "Color" },
  { id: "category", label: "Category" },
  { id: "action", label: "Action" },
];

export default function ReadyMasterRangeList(props) {
  const classes = useStyles();
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [ready, setReady] = useState([]);
  const [total, setTotal] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [readyMasterRange, setReadyMasterRange] = useState([]);
  console.log("121", readyMasterRange)
  const [tota, setTota] = useState(0);
  const [openMultipleProductAddDialog, setOpenMultipleProductAddDialog] =
    useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  useEffect(() => {
    _getBulkReadyMasterRangeAPI(page, rowsPerPage);
  }, [openMultipleProductAddDialog, openEditDialog, page, rowsPerPage]);

  useEffect(() => {
    _getReady();
  }, [page, rowsPerPage]);

  async function searchData(term) {
    setLoading(true);
    setSearchTerm(term);
    try {
      const query = `&limit=${rowsPerPage}&skip=${page * rowsPerPage}&productName=${encodeURIComponent(term || "")}&color=${encodeURIComponent(term || "")}`;
      let res = await axios.get(
        GetBulkReadyMasterRangeAPI(userInfo.entity) + query,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setReadyMasterRange(res.data.readyMasterRange || []);
      setTota(res.data.total ?? 0);
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setLoading(false);
    }
  }

  async function _getBulkReadyMasterRangeAPI(page, rowsPerPage) {
    setLoading(true);
    try {
      let res = await axios.get(GetBulkReadyMasterRangeAPI(userInfo.entity) +
        `&limit=${rowsPerPage}&skip=${page * rowsPerPage}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log("aaya", res.data)
      setReadyMasterRange(res.data.readyMasterRange);
      setTota(res.data.total)
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.message || "Failed to load Ready Master Range data. Please Contact Admin", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  }

  async function _deleteItem(item) {
    setDeletingId(item._id);
    try {
      let res = await axios.delete(DeleteReadyMasterRangeAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success('Ready Master Range deleted successfully!', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Refresh data instead of reloading page
      await _getBulkReadyMasterRangeAPI(page, rowsPerPage);
    } catch (e) {
      console.log("err:", e);
      toast.error(e.response?.data?.message || "Something went wrong, Please Contact Admin", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setDeletingId(null);
    }
  }

  async function _getReady() {
    console.log("202")
    try {
      let res = await axios.get(
        GetAllReadyMastersAPI(userInfo.entity) +
        `&limit=${rowsPerPage}&skip=${page * rowsPerPage}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setReady(res.data.readyMasters);
      setTotal(res.data.total);
    } catch (err) {
      // console.log(err);
      toast.error(("Something went wrong, Please Contact Admin"), {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeMultipleProductAddDialog() {
    setOpenMultipleProductAddDialog(false);
  }

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  let data = readyMasterRange;
  if (searchTerm && searchTerm.trim() !== "") {
    const t = searchTerm.toLowerCase().trim();
    data = _.filter(readyMasterRange, (i) => {
      const productMatch = i.productName && i.productName.toLowerCase().includes(t);
      const colorMatch = i.color && String(i.color).toLowerCase().includes(t);
      return productMatch || colorMatch;
    });
  }

  function handleSearch() {
    searchData(search);
  }

  // Handler for export button: generate Excel from readyMasterRange
  const handleExport = async () => {
    setIsExporting(true);
    const loadingToastId = toast.loading('🔄 Preparing export... Please wait', {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });

    try {
      // First, get the total count
      toast.update(loadingToastId, {
        render: '📊 Fetching total record count...',
        type: 'info',
        isLoading: true,
      });

      const totalRes = await axios.get(
        GetBulkReadyMasterRangeAPI(userInfo.entity) + `&limit=1&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const total = totalRes.data.total || 0;
      
      if (total === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      // Fetch all data using the total count
      toast.update(loadingToastId, {
        render: `📥 Downloading ${total} records... This may take a moment`,
        type: 'info',
        isLoading: true,
      });

      const res = await axios.get(
        GetBulkReadyMasterRangeAPI(userInfo.entity) + `&limit=${total}&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const allData = res.data.readyMasterRange;
      if (!allData || allData.length === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      toast.update(loadingToastId, {
        render: `⚙️ Processing ${allData.length} records...`,
        type: 'info',
        isLoading: true,
      });

      const exportHeadings = [
        { id: "productName", label: "Product" },
        { id: "startSph", label: "Start Sph" },
        { id: "endSph", label: "End Sph" },
        { id: "startCyl", label: "Start Cyl" },
        { id: "endCyl", label: "End Cyl" },
        { id: "startAddition", label: "Start Addn" },
        { id: "endAddition", label: "End Addn" },
        { id: "axis", label: "Axis" },
        { id: "index", label: "Index" },
        { id: "side", label: "Side" },
        { id: "rate", label: "Rate" },
        { id: "type", label: "Type" },
        { id: "brand", label: "Brand" },
        { id: "color", label: "Color" },
        { id: "category", label: "Category" }
      ];

      const exportData = allData.map(row => {
        const rowData = {};
        exportHeadings.forEach(col => {
          let value = row[col.id];
          if (col.id === 'axis' && Array.isArray(value)) {
            value = value.join(',');
          }
          if ((col.id === 'brand' || col.id === 'category') && value && value.name) {
            value = value.name;
          }
          rowData[col.id] = value;
        });
        return rowData;
      });
      toast.update(loadingToastId, {
        render: '💾 Generating Excel file...',
        type: 'info',
        isLoading: true,
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ReadyMasterRange');
      XLSX.writeFile(workbook, 'ready_master_range_export.xlsx');

      toast.update(loadingToastId, {
        render: `✅ Successfully exported ${allData.length} records to Excel!`,
        type: 'success',
        isLoading: false,
        autoClose: 4000,
        style: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } catch (error) {
      console.error('Export error:', error);
      toast.update(loadingToastId, {
        render: `❌ Export failed: ${error.response?.data?.message || error.message || 'Unknown error'}`,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        style: {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <GridContainer
      // style={{ overflow: 'auto', width: '100rem',  }}
      style={{ overflow: 'auto', width: '100rem', maxWidth: '100rem' }}

    >
      <GridItem
        // xs={12} sm={12} md={12}
        style={{ width: "100%" }}
      >
        <Card style={{ width: "100%" }}>
          <CardHeader color="primary">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <h4 className={classes.cardTitleWhite}>Ready Master Range</h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <CustomInput
                  id="search"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    style: {
                      color: "primary",
                      marginTop: 0,
                    },
                    placeholder: "Search by code....",
                    value: search,
                    onChange: (e) => {
                      setSearch(e.target.value);
                      if (e.target.value === "" || e.target.value === null || e.target.value === undefined) {
                        _getReady();
                      }
                    },
                    onKeyDown: (e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        handleSearch();
                      }
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton color={"secondary"} onClick={(e) => {
                          handleSearch()
                        }}>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {/* Export Button (now triggers Excel download) */}
                <Tooltip title="Export to Excel" arrow>
                  <span>
                    <IconButton
                      aria-label="export"
                      style={{ color: "white" }}
                      onClick={handleExport}
                      disabled={isExporting}
                    >
                      {isExporting ? <CircularProgress size={24} color="inherit" /> : <CloudDownloadIcon />}
                    </IconButton>
                  </span>
                </Tooltip>
                {/* Import Button */}
                <Tooltip title="Import Excel to database" arrow>
                  <IconButton
                    aria-label="import"
                    style={{ color: "white" }}
                    onClick={() => setOpenImportDialog(true)}
                  >
                    <CloudUpload />
                  </IconButton>
                </Tooltip>
                {/* Skeleton Download Button */}
                <Tooltip title="Download Import Skeleton Template" arrow>
                  <IconButton
                    aria-label="download skeleton"
                    style={{ color: "white" }}
                    onClick={() => {
                      const exportHeadings = [
                        { id: "readyMasterImages[0]", label: "Image" },
                        { id: "axis", label: "Axis" },
                        { id: "productName", label: "Product Name" },
                        { id: "index", label: "Index" },
                        { id: "side", label: "Side" },
                        { id: "type", label: "Type" },
                        { id: "color", label: "Color" },
                        { id: "rate", label: "Rate" },
                        { id: "startSph", label: "Start Sph" },
                        { id: "endSph", label: "End Sph" },
                        { id: "startCyl", label: "Start Cyl" },
                        { id: "endCyl", label: "End Cyl" },
                        { id: "startAddition", label: "Start Addition" },
                        { id: "endAddition", label: "End Addition" },
                        { id: "brand", label: "Brand" },
                        { id: "category", label: "Category" },
                        { id: "hsnCode", label: "HSN Code" },
                        { id: "taxPercent", label: "Tax Percent" }
                      ];
                      // Create a single row with keys as column headers
                      const skeletonData = [Object.fromEntries(exportHeadings.map(h => [h.id, '']))];
                      const worksheet = XLSX.utils.json_to_sheet(skeletonData, { header: exportHeadings.map(h => h.id) });
                      // Overwrite the first row with labels
                      XLSX.utils.sheet_add_aoa(worksheet, [exportHeadings.map(h => h.id)], { origin: 0 });
                      const workbook = XLSX.utils.book_new();
                      XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');
                      XLSX.writeFile(workbook, 'ready_master_range_import_template.xlsx');
                      toast.success('Skeleton template downloaded!');
                    }}
                  >
                    <CloudDownloadIcon
                    // style={{ transform: 'rotate(180deg)' }} 
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Add Multiple Products" arrow>
                  <IconButton
                    aria-label="add"
                    style={{ color: "white" }}
                    onClick={() => setOpenMultipleProductAddDialog(true)}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </CardHeader>

          <CardBody>
            <Table stickyHeader aria-label="sticky table"
              // style={{ width: '50%' }} 
              style={{ width: "100%" }}
              xs={12} sm={12} md={12}
            >
              <TableHead>
                <TableRow>
                  {/* <Checkbox
                    style={{
                      color: "#512da8",
                    }}
                    onChange={(e) => {
                      let c = [];
                      if (e.target.checked) {
                        data.map((i) => {
                          c.push(i._id);
                        });
                      }
                      setSelectedRows(c);
                    }}
                    checked={
                      selectedRows.length > 0 &&
                      data.length === selectedRows.length
                    }
                    inputProps={{ "aria-labelledby": -1 }}
                  /> */}
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={"center"}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                      <CircularProgress />
                      <Box style={{ color: "#666", marginTop: "16px" }}>
                        {searchTerm ? "Searching products..." : "Loading products..."}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : data.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center" style={{ padding: "40px" }}>
                      <Box style={{ color: "#666" }}>
                        {searchTerm ? "No products found matching your search." : "No products found."}
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  data
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        {/* <TableCell padding="checkbox">
                          <Checkbox
                            style={{
                              color: "#512da8",
                            }}
                            onChange={() => {
                              let copy = _.clone(selectedRows);
                              if (_.includes(copy, row._id)) {
                                let index = _.indexOf(copy, row._id);
                                copy.splice(index, 1);
                              } else {
                                copy.push(row._id);
                              }
                              setSelectedRows(copy);
                            }}
                            checked={_.includes(selectedRows, row._id)}
                            inputProps={{ "aria-labelledby": row._id }}
                          />
                        </TableCell> */}
                        {columns.map((column) => {
                          const value = row[column.id];

                          if (column.id === "action") {
                            return (
                              <TableCell align={"center"}>
                                <Box display={"flex"} justifyContent={"center"}>
                                  <IconButton
                                    onClick={() =>
                                      setOpenViewDialog({
                                        open: true,
                                        item: row,
                                      })
                                    }
                                    aria-label="view"
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() =>
                                      setOpenEditDialog({
                                        open: true,
                                        item: row,
                                      })
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleOpenConfirmationModal({
                                        title: "Delete Record",
                                        msg: "Deleting this will result in total deletion of the product from this and all other related modules where this product has been linked. Do you want to delete this record?",
                                        onPress: () => _deleteItem(row),
                                      })
                                    }
                                    aria-label="delete"
                                    disabled={deletingId === row._id}
                                  >
                                    {deletingId === row._id ? (
                                      <CircularProgress size={20} />
                                    ) : (
                                      <DeleteIcon />
                                    )}
                                  </IconButton>
                                </Box>
                              </TableCell>
                            );
                          }
                          if (column.id === "status") {
                            return (
                              <TableCell align={'center'}>
                                <Switch defaultChecked={value === "Active" ? true : false} color="purple" />
                              </TableCell>
                            )
                          }

                          if (
                            column.id === "brand" ||
                            column.id === "category"
                          ) {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value?.name}
                              </TableCell>
                            );
                          }

                          return (
                            <TableCell key={column.id} align={"center"}>
                              {column.format && (typeof value === "number" || !isNaN(Number(value)))
                                ? column.format(Number(value))
                                : column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                    })
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={tota}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardBody>
        </Card>
      </GridItem>
      <ReadyMasterRangeAdd
        fetchData={() => _getBulkReadyMasterRangeAPI(page, rowsPerPage)}
        open={openMultipleProductAddDialog}
        close={closeMultipleProductAddDialog}
      />
      {openViewDialog ? (
        <ReadyMasterRangeView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}

      {openEditDialog ? (
        <ReadyMasterRangeEdit
          open={openEditDialog.open}
          close={closeEditDialog}
          item={openEditDialog.item}
          fetchData={() => _getBulkReadyMasterRangeAPI(page, rowsPerPage)}
        />
      ) : null}

      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={"Delete Record"}
          msg={
            "Deleting this will result in total deletion of the product from this and all other related modules where this product has been linked. Do you want to delete this record?"
          }
        />
      ) : null}
      <ImportExcel
        db={"readyMasterRange"}
        open={openImportDialog}
        close={() => {
          setOpenImportDialog(false);
          _getBulkReadyMasterRangeAPI(page, rowsPerPage);
        }}
      />
      <Backdrop
        open={isExporting}
        style={{
          zIndex: 9999,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={60} thickness={4} style={{ color: '#512da8', marginBottom: 20 }} />
          <Box style={{ fontSize: '18px', fontWeight: 'bold', marginTop: 10 }}>
            Exporting Data...
          </Box>
          <Box style={{ fontSize: '14px', marginTop: 5, opacity: 0.8 }}>
            Please wait while we prepare your Excel file
          </Box>
        </Box>
      </Backdrop>
    </GridContainer>
  );
}
